import React from 'react';
import styles from './CoreList.module.scss';
import className from 'classnames/bind';
import { gql } from '@apollo/client';
import { WordPressBlocksViewer } from '@faustwp/blocks';
import formatStyles from '@/helpers/formatStyles';

let cx = className.bind(styles);

export default function CoreList({ attributes, innerBlocks }) {
	const styles = formatStyles(attributes.style);
	const className = attributes.className?.split(' ') || [];
	const ListLevel = (attributes === null || attributes === void 0 ? void 0 : attributes.ordered) ? 'ol' : 'ul';

	function InnerBlocks() {
		return React.createElement(WordPressBlocksViewer, { blocks: innerBlocks !== null && innerBlocks !== void 0 ? innerBlocks : [] });
	}

	return React.createElement(
		ListLevel,
		{
			id: attributes.anchor,
			className: cx(['ns_list', 'list', ...className, attributes.backgroundColor && `bg-${attributes.backgroundColor}`, attributes.fontSize && `is-font-size-${attributes.fontSize}`, attributes.textColor && `text-color-${attributes.textColor}`]),
			style: { ...styles, listStyleType: attributes.type },
			reversed: attributes.reversed,
			start: attributes.start,
		},
		<InnerBlocks />
	);
}

CoreList.fragments = {
	key: `CoreListFragment`,
	entry: gql`
		fragment CoreListFragment on CoreList {
			attributes {
				anchor
				backgroundColor
				className
				fontSize
				ordered
				reversed
				start
				style
				type
				values
        textColor
			}
		}
	`,
};

CoreList.config = {
	name: 'CoreList',
};
CoreList.displayName = 'CoreList';
